// src/pages/OfficesPage.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  IconButton,
  Link,
  useTheme
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PeopleIcon from '@mui/icons-material/People';

const offices = [
  {
    name: 'Middlesbrough (Head Office)',
    salesPhone: '01642 243378',
    lettingsPhone: '01642 243378',
    email: 'info@mrmlettings.co.uk',
    addressLines: ['142 Victoria Road', 'Middlesbrough', 'TS1 3HU'],
    teamLink: '/about#team',
  },
];

export default function OfficesPage() {
  const theme = useTheme();

  return (
    <Box component="main">
      {/* Hero / Banner */}
      <Box
        sx={{
          position: 'relative',
          py: { xs: 6, md: 12 },
          backgroundImage: 'url(https://michaelpoole.co.uk/assets/e4166bb/images/covers/Michael-Poole-Estate-Agents-Teesside-Middlesbrough-1221699856-min.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#fff',
          textAlign: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(0,0,0,0.4)',
          },
        }}
      >
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.85)' }}>
            Our Office
          </Typography>
          <Typography variant="h3" fontWeight={700} sx={{ mt: 1 }}>
            Where to find us
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: { xs: 4, md: 8 }, mb: { xs: 6, md: 12 } }}>
        {/* Office grid */}
        <Grid container spacing={4}>
          {offices.map((office) => (
            <Grid item xs={12} sm={6} md={4} key={office.name}>
              <Card
                elevation={3}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
              >
                <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOnIcon color="primary" fontSize="large" />
                  <Typography variant="h6" fontWeight={600}>
                    {office.name}
                  </Typography>
                </Box>
                <CardContent sx={{ pt: 0, flexGrow: 1 }}>
                  <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                    <PhoneIcon fontSize="small" color="action" />
                    <Typography variant="body2">
                      <strong>Sales:</strong> {office.salesPhone}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                    <PhoneIcon fontSize="small" color="action" />
                    <Typography variant="body2">
                      <strong>Lettings:</strong> {office.lettingsPhone}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                    <EmailIcon fontSize="small" color="action" />
                    <Link
                      href={`mailto:${office.email}`}
                      underline="hover"
                      color="text.primary"
                      sx={{ wordBreak: 'break-all' }}
                    >
                      {office.email}
                    </Link>
                  </Box>
                  {office.addressLines.map((line, idx) => (
                    <Typography variant="body2" color="text.secondary" key={idx}>
                      {line}
                    </Typography>
                  ))}
                </CardContent>
                <CardActions
                  sx={{ justifyContent: 'space-between', px: 2, pb: 2, pt: 0 }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    href="/contact"
                    startIcon={<PhoneIcon />}
                  >
                    Get in Touch
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    href={office.teamLink}
                    startIcon={<PeopleIcon />}
                  >
                    Meet the Team
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
